@let group = form();
<form class="view-settings pt-1 pb-3 flex flex-col gap-3 text-[13px] text-headline" [formGroup]="group" (ngSubmit)="apply()">
  <p class="m-0 text-[12px] text-secondary-500">{{ hint() }}</p>

  <label class="flex flex-col gap-1">
    <span class="text-[12px]">Sort by</span>
    <select
      class="h-9 rounded border border-secondary-200 bg-white px-2 text-[13px]"
      formControlName="sort"
      [attr.data-testid]="'view-settings-sort'"
    >
      <option value="default">Default</option>
      @for (sort of source().sorts; track sort.key) {
        <option [value]="sort.key">{{ sort.label }}</option>
      }
    </select>
  </label>

  <label class="flex items-center gap-2">
    <input type="checkbox" formControlName="reverse" />
    <span>Reverse order</span>
  </label>
  <label class="flex items-center gap-2">
    <input
      type="checkbox"
      formControlName="flaggedOnly"
      [attr.aria-describedby]="source().flaggedLocked ? id + '-flagged-note' : null"
    />
    <span>Flagged only</span>
  </label>
  @if (source().flaggedLocked) {
    <p class="m-0 -mt-2 pl-6 text-[12px] text-secondary-500" [id]="id + '-flagged-note'">
      This view always shows flagged items.
    </p>
  }
  <label class="flex items-center gap-2">
    <input type="checkbox" formControlName="pinnedOnly" />
    <span>Pinned only</span>
  </label>
  @if (source().withUnread) {
    <label class="flex items-center gap-2">
      <input type="checkbox" formControlName="unreadOnly" />
      <span>Unread only</span>
    </label>
  }

  <div class="view-settings-footer flex justify-end gap-2 border-t border-secondary-150 pt-3">
    <app-button2 appearance="secondary" size="m" [paddingX]="10" (click)="cancelled.emit()">Cancel</app-button2>
    <app-button2 appearance="primary" size="m" [paddingX]="10" (click)="apply()">Apply</app-button2>
  </div>
</form>
